<template>
  <div v-html="content_section">

    <!--section class="p_120">
        <div class="container">

          <div class="main_title">
            <h2>Clientes</h2>
          </div>
            <div class="clients_slider owl-carousel">
                <div class="item text-center"> 
                  <a href="http://grupocentrocon.com.br" target="_blank">
                    <img src="/img/clients-logo/controcon.jpg" alt="Centrocon">
                  </a>
                  <a href="https://www.rededorsaoluiz.com.br/star/dfstar"  target="_blank">
                    <img src="/img/clients-logo/dfstar.jpg" alt="DF Star">
                  </a>
                  <a href="https://www.hospitalbrasilia.com.br"  target="_blank">
                    <img src="/img/clients-logo/hbrasilia.jpg" alt="Hospital Brasília">
                  </a>
                  <a href="https://www.hospitalsiriolibanes.org.br"  target="_blank">
                    <img src="/img/clients-logo/slibanes.jpg" alt="Hospital Sírio Libanês Brasília">
                  </a>
                </div>
            </div>
        </div>
    </section -->

  </div>
</template>

<script>
  export default {
    name: 'Clients',
    props: {
      content_section: String,
    },
  }
</script>

<style>
.clients_slider img{
  padding: 30px;
}

</style>